import { createContext } from "react";

import type { Impulse } from "~/tools/impulse";

import type { ExplorationDrawerState, ExplorationDrawerTable } from "./ExplorationDrawerState";

export interface ExplorationDrawerStateContextValue {
	drawers: Impulse<ReadonlyArray<ExplorationDrawerTable>>;
	state: ExplorationDrawerState;
}

export const ExplorationDrawerStateContext = createContext<null | ExplorationDrawerStateContextValue>(null);
